import React from "react";
import cx from "classnames";
import styles from "./ActiveOptionChip.module.scss";
import Chip from "components/common/ui/chip/Chip";
import { IFacetOption } from "models/Dimension";
import IconCancel from "components/common/icons/IconCancel";

interface Props extends IFacetOption, DefaultProps {
  onClick?: (key: string) => void;
  id: string;
  className?: string;
  cancelIcon?: boolean;
  theme?: ThemeVariants;
  variant?: FillVariants;
}

const ActiveOptionChip = React.memo(
  ({
    color,
    onClick,
    className,
    cancelIcon,
    theme = "primary",
    variant,
    children,
    ...props
  }: Props) => {
    const styleProps = color
      ? {
          style: { color, background: color + 28 },
          iconStyle: { color, background: color + 28 },
        }
      : {};
    const clickProps = onClick
      ? {
          onClick: (e: Event) => {
            e.stopPropagation();
            onClick(props.id);
          },
          onMouseDown: (e: Event) => {
            e.preventDefault();
          },
        }
      : {};
    return (
      <Chip
        {...props}
        {...styleProps}
        className={cx(styles.root, className, cancelIcon && styles.cancel)}
        theme={theme}
        condensed
        variant={variant}
        {...clickProps}
      >
        {children || props.label || props.id}{" "}
        {cancelIcon && <IconCancel className={styles.iconCancel} />}
      </Chip>
    );
  }
);

export default ActiveOptionChip;
